module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Confirmer l'envoi")]), _vm._v(" "), (_vm.documentReady) ? _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "48px",
      "color": "white",
      "background-color": "red"
    }
  }, [_c('div', {
    staticClass: "md-headline"
  }, [_vm._v("Dossier déjà validé")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "48px",
      "align-items": "center",
      "flex-direction": "column"
    }
  }, [_c('md-button', {
    staticClass: "md-accent",
    on: {
      "click": function($event) {
        return _vm.onClickView()
      }
    }
  }, [_vm._v("Visualiser le PDF")]), _vm._v(" "), (!_vm.confirmed && !_vm.documentReady) ? _c('md-button', {
    staticClass: "md-raised md-primary large-button",
    attrs: {
      "disabled": !_vm.pdfOpened || _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.onClickConfirm()
      }
    }
  }, [_vm._v("Confirmer l'envoi au Client")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fb5d9c2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/ReviewConfirm.vue
// module id = 741
// module chunks = 3